<app-expediente-modal></app-expediente-modal>

<div class="app-wrapper">

  <!-- Farol do tour (D49/D50): substitui o scrim. Só pinta algo quando há alvo aceso, então não
       precisa de guarda por `isTourMode` — a guarda de rota continua valendo. -->
  @if (tourPermitido()) {
    <tour-realce />
  }

  <!-- O tour guiado (balão do roteiro) não existe em pdv./admin. — spec §9: a travessia de
       hostname é da Fase 4. Mesma exclusão do ai-idle-help.service.ts. O convite (D70) migrou
       para o orbe do assistente (GuiaOneService + guia-teaser, Task 4) — canto direito, junto
       do chat, em vez deste canto esquerdo. -->
  @if (tourPermitido()) {
    <app-tour-guia />
  }

  <main class="app-content">

    @if (showMenu) {
      <app-menu [showSearch]="showSearch">
        <router-outlet></router-outlet>
      </app-menu>
    }

    @if (!showMenu) {
      <router-outlet></router-outlet>
    }

  </main>

  @if (showFooter && !showMenu) {
    <footer class="footer">
      <div>
        <span class="footer-text">
          Powered by
        </span>
        <a [href]="environment.urlSite" target="_blank">
          <img [src]="marcaDagua" [alt]="title" />
        </a>
        @if (!isAdmin) {
        }
      </div>
    </footer>
  }

  @if (!isAdmin) {
    <!-- Casca acoplada (T7): montada só quando aberto+painel. O overlay continua SEMPRE montado —
         é o dono do launcher, dos balões (teasers) e do init de idle-help/proatividade/alertas;
         com `acoplado()` true ele mesmo esconde seu palco/chat (`!layout.acoplado()` no seu
         template), então não há duplicidade de UI. -->
    @if (layout.acoplado()) {
      <!-- animate.leave (Angular 20.2+) tem que ficar no nó que ESTE @if remove — o host —, não no
           <aside> interno (o Angular só olha as animações de saída do próprio nó removido). O host
           ganha a classe e o CSS do painel anima o aside a partir de :host(.ai-painel-sai). -->
      <ai-painel animate.leave="ai-painel-sai"></ai-painel>
    }
    <ai-assistant-overlay></ai-assistant-overlay>
    <ai-realce [style.--ai-accent]="aiAgent.corMarca() || null" />
  }

  @if (aiAgent.alertaContextual(); as alerta) {
    <div class="ai-contextual-banner" role="status">
      <span>{{ alerta.titulo }}</span>
      <button type="button" (click)="aiAgent.enviarPerguntaDoAlerta(alerta)">{{ alerta.perguntaSugerida }}</button>
      <button type="button" (click)="aiAgent.dispensarAlerta(alerta.id)" aria-label="Dispensar">×</button>
    </div>
  }

</div>